import { Box, Typography, Divider } from '@mui/material'
import { styled } from '@mui/system'
import { ASPECT_RATIO } from 'zoom/config'
import { Alert, CustomPopover } from 'hello-design-system'

export const InnerWrapper = styled(Box)(() => ({
    display: 'flex',
    margin: 'auto',
    textAlign: 'center',
    width: '100%',
    position: 'relative',
    zIndex: 1
}))

export const CustomPopoverWrapper = styled(CustomPopover)({
    pointerEvents: 'none'
})

export const PopoverWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    padding: theme.spacing(2),
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.background?.default
}))

export const TileWrapper = styled(Box)(({ theme }) => ({
    backgroundColor: 'rgba(241, 241, 241)',
    borderRadius: theme.spacing(2.5),
    width: '100%',
    maxWidth: theme.spacing(67.75),
    aspectRatio: `${ASPECT_RATIO}`,
    margin: theme.spacing('0', '0', '0', 'auto')
}))

export const textStyle = styled(Box)(({ theme }) => ({
    lineHeight: '150%',
    letterSpacing: '0.02em',
    marginTop: theme.spacing(1.5)
}))

export const MessageTitleWrapper = styled(textStyle)(({ theme }) => ({
    fontWeight: 800,
    fontSize: theme.spacing(3),
    color: theme.palette.primary?.main
}))

export const MessageRemainingTimeWrapper = styled(textStyle)(({ theme }) => ({
    fontWeight: 400,
    marginTop: '0',
    fontSize: theme.spacing(2),
    color: theme.palette.primary?.darker,
    span: {
        fontWeight: 700
    }
}))

export const IconsContainer = styled(Box)(({ theme }) => ({
    marginLeft: theme.spacing(2)
}))

export const ButtonContainer = styled(Box)(({ theme }) => ({
    display: 'flow',
    maxWidth: theme.spacing(67.75),
    margin: theme.spacing('auto', 'auto', 'auto', 3),
    alignItems: 'center',
    justifyContent: 'space-between'
}))

export const Tile = styled(Box, {
    shouldForwardProp: prop => prop !== 'showVideo'
})<{ showVideo: boolean }>(({ theme, showVideo }) => ({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    height: '100%',
    width: '100%',
    backgroundColor: showVideo ? 'transparent' : theme.palette.grey?.[100],
    borderRadius: theme.spacing(2.5),
    willChange: 'background-color',
    transition: 'background-color 0.2s ease-out',
    '& video-player-container': {
        '& video-player': {
            '& canvas': {
                width: '100% !important',
                height: '100% !important',
                objectFit: 'cover',
                borderRadius: 'inherit'
            }
        }
    }
}))

export const Avatar = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: theme.spacing(3),
    fontWeight: 800,
    height: theme.spacing(16.5),
    maxHeight: theme.spacing(20),
    aspectRatio: '1',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary?.darker + '59',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: theme.palette.background?.default
}))

export const AudioControls = styled(Box)(({ theme }) => ({
    width: '100%',
    height: theme.spacing(5),
    margin: theme.spacing(2),
    boxSizing: 'border-box',
    display: 'flex',
    position: 'absolute'
}))

export const ExtraLargeIcon = styled('img')(({ theme }) => ({
    height: theme.spacing(5),
    width: theme.spacing(5),
    marginLeft: theme.spacing(2)
}))

export const ParticipantInitials = styled(Typography)(({ theme }) => ({
    fontSize: theme.spacing(4.5),
    lineHeight: '106%'
}))

export const IconButtonContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3)
}))

export const PrivacyPolicy = styled(Box)(({ theme }) => ({
    fontSize: theme.spacing(1.75),
    fontWeight: 400,
    textAlign: 'left',
    a: {
        textDecoration: 'underline',
        textDecorationSkipInk: 'none',
        textUnderlineOffset: theme.spacing(0.375)
    }
}))

export const AlertContent = styled(Alert)<{ warning?: boolean }>(({ theme, warning = false }) => ({
    display: 'flex',
    marginBottom: theme.spacing(3),
    borderRadius: `${theme.spacing(1)} !important`,
    // backgroundColor: `${warning ? theme.palette.warning?.main + '14' : theme.palette.info?.main + '14'} !important`,
    '&.vb-dialog': {
        '.MuiAlert-message': {
            color: `${theme.palette.info?.dark} !important`,
            fontWeight: 400,
            fontSize: `${theme.spacing(1.75)} !important`
        }
    },
    '&.MuiAlert-action': {
        padding: `${theme.spacing(0.5)} !important`
    },
    '.MuiAlert-message': {
        // color: `${warning ? theme.palette.warning?.dark : theme.palette.info?.dark} !important`,
        fontWeight: 400,
        fontSize: `${theme.spacing(1.75)} !important`,
        textAlign: 'start',
        width: warning ? theme.spacing(37.125) : 'unset'
    }
}))

export const ButtonMessage = styled(Typography)(({ theme }) => ({
    fontWeight: 700,
    fontSize: theme.spacing(1.625)
}))

export const Separator = styled(Divider)(({ theme }) => ({
    borderRight: `1px solid ${theme.palette.grey?.[300]}`,
    marginLeft: theme.spacing(2),
    height: theme.spacing(6)
}))
